import HttpError from './HttpError';

export default class AtsConnectionNotReadyError extends HttpError {}
